// extracted by mini-css-extract-plugin
module.exports = {"Loader":"ReactSpinnerLoader_Loader__2l3r_"};